import { useLayoutEffect, useRef } from "react";

/**
 * Scrolls its own subtree to the top of the nearest scroll container while
 * `isActive` holds — the UI machinery behind a deep link that lands inside a
 * long panel rather than at its start.
 *
 * A business component may not own a ref or an effect (see AGENTS.md), so the
 * DOM node and its layout effect live here. The effect is a layout one on
 * purpose: it runs before paint, so the reader never sees the panel at its
 * top before it jumps to the anchored section.
 */
export function ScrollAnchor({
  isActive,
  className,
  children,
}: {
  isActive: boolean;
  className: string;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement | null>(null);
  useLayoutEffect(() => {
    if (!isActive) return;
    const node = ref.current;
    if (node === null) return;
    node.scrollIntoView({ block: "start" });
  }, [isActive]);
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
